import { useMemo } from 'react'
import { useIntl } from 'react-intl'
import { CruiseContentSections } from 'constants/cruise'

type CruiseContentSectionLabels = Record<Exclude<CruiseContentSections, CruiseContentSections.GALLERY>, string>

function useCruiseContentSectionLabels(): CruiseContentSectionLabels {
  const intl = useIntl()

  return useMemo(() => ({
    [CruiseContentSections.OVERVIEW]: intl.formatMessage({
      id: 'dGNmyqFDWY',
      defaultMessage: 'Overview',
      description: 'Cruise content section label for overview',
    }),
    [CruiseContentSections.ITINERARY]: intl.formatMessage({
      id: 'ACNPIq5xPP',
      defaultMessage: 'Itinerary',
      description: 'Cruise content section label for itinerary',
    }),
    [CruiseContentSections.ABOUT_THE_SHIP]: intl.formatMessage({
      id: '7T+roAd8ds',
      defaultMessage: 'About the Ship',
      description: 'Cruise content section label for ship information',
    }),
    [CruiseContentSections.DEPARTURES]: intl.formatMessage({
      id: 'BjG7f4YAot',
      defaultMessage: 'Dates & Pricing',
      description: 'Cruise content section label for departure dates and pricing',
    }),
    [CruiseContentSections.DECKS_AND_CABINS]: intl.formatMessage({
      id: '+R5eF2Xxdr',
      defaultMessage: 'Decks & Cabin types',
      description: 'Cruise content section label for decks and cabin types',
    }),
    [CruiseContentSections.FINE_PRINT]: intl.formatMessage({
      id: 'wQhnT8akR7',
      defaultMessage: 'Things to know',
      description: 'Cruise content section label for fine print',
    }),
    [CruiseContentSections.FAQ]: intl.formatMessage({
      id: 'D8ahopWLT9',
      defaultMessage: 'Frequently Asked Questions',
      description: 'Cruise content section label for FAQ',
    }),
  }), [intl])
}

export default useCruiseContentSectionLabels
